/* eslint-disable */
// Dashboard.jsx
import { useState, useEffect } from 'react';
import StatCard from '../components/StatCard';
import Topbar  from '../components/Topbar';
import { pengadaanAPI, gudangAPI, keuanganAPI } from '../services/api';

function formatRp(n) { return 'Rp ' + Number(n||0).toLocaleString('id-ID'); }

function badgeStatusPO(status) {
  const map = { approved:'✅ Disetujui', menunggu:'⏳ Menunggu', rejected:'❌ Ditolak', draft:'📝 Draft' };
  const cls = { approved:'hijau', menunggu:'orange', rejected:'merah', draft:'' };
  return <span className={`badge ${cls[status]||''}`}>{map[status]||status}</span>;
}

function waktuRelatif(tgl) {
  if (!tgl) return '-';
  const now = new Date();
  const d = new Date(tgl);
  const diffMs = now - d;
  const menit = Math.floor(diffMs/60000);
  const jam   = Math.floor(menit/60);
  const hari  = Math.floor(jam/24);
  if (menit < 1) return 'baru saja';
  if (menit < 60) return `${menit} menit lalu`;
  if (jam < 24) return `${jam} jam lalu`;
  if (hari < 30) return `${hari} hari lalu`;
  return d.toLocaleDateString('id-ID', { day:'numeric', month:'short', year:'numeric' });
}

function Dashboard({ user }) {
  const [stats, setStats]           = useState({ totalPO:0, totalNilaiPO:0, stokMenipis:0, totalKas:0, totalPiutang:0 });
  const [poTerbaru, setPoTerbaru]   = useState([]);
  const [aktivitas, setAktivitas]   = useState([]);
  const [tindakan, setTindakan]     = useState([]);
  const [loading, setLoading]       = useState(true);

  useEffect(() => { fetchDashboard(); }, []);

  async function fetchDashboard() {
    setLoading(true);
    try {
      const [poRes, stokRes, ringkasanRes, kasbonRes, grRes] = await Promise.all([
        pengadaanAPI.getAllPO(),
        gudangAPI.getStok(),
        keuanganAPI.getLaporanRingkasan(),
        keuanganAPI.getAllPengajuanKas(),
        pengadaanAPI.getAllGR(),
      ]);

      const poList     = poRes.ok       ? poRes.data.data       : [];
      const stokList    = stokRes.ok     ? stokRes.data.data     : [];
      const ringkasan   = ringkasanRes.ok ? ringkasanRes.data.data : null;
      const kasbonList  = kasbonRes.ok   ? kasbonRes.data.data   : [];
      const grList      = grRes.ok       ? grRes.data.data       : [];

      const totalNilaiPO = poList.reduce((s,p)=>s+Number(p.total_nilai||0),0);
      const stokMenipis  = stokList.filter(s => Number(s.stok_minimum)>0 && Number(s.qty)<=Number(s.stok_minimum));

      setStats({
        totalPO: poList.length,
        totalNilaiPO,
        stokMenipis: stokMenipis.length,
        totalKas: ringkasan?.total_kas || 0,
        totalPiutang: ringkasan?.total_piutang || 0,
      });

      // PO terbaru — 5 teratas
      const poSorted = [...poList]
        .sort((a,b)=> new Date(b.created_at||0) - new Date(a.created_at||0))
        .slice(0,5);
      setPoTerbaru(poSorted);

      // AKTIVITAS TERBARU — gabungan 3 modul
      const gabungan = [
        ...poList.map(p => ({
          teks:  `SPB ${p.no_spb} — ${p.status==='approved'?'disetujui':p.status==='rejected'?'ditolak':'diajukan'}`,
          waktu: p.created_at,
          modul: 'Pengadaan',
          dot:   p.status==='approved'?'hijau':p.status==='rejected'?'merah':'orange',
        })),
        ...grList.map(g => ({
          teks:  `BAPB ${g.no_bapb} — penerimaan barang dicatat`,
          waktu: g.created_at || g.tgl_terima,
          modul: 'Gudang',
          dot:   'biru',
        })),
        ...kasbonList.map(k => ({
          teks:  `Pengajuan Kas ${k.no_pengajuan} — ${k.status}`,
          waktu: k.created_at || k.tanggal,
          modul: 'Keuangan',
          dot:   k.status==='disetujui'||k.status==='dicairkan'?'hijau':k.status==='ditolak'?'merah':'orange',
        })),
      ]
        .filter(a => a.waktu)
        .sort((a,b)=> new Date(b.waktu) - new Date(a.waktu))
        .slice(0,6);
      setAktivitas(gabungan);

      // PERLU TINDAKAN — dari 3 modul
      const daftarTindakan = [
        ...poList.filter(p=>p.status==='menunggu').map(p=>({
          teks: `Approve SPB ${p.no_spb} — ${p.nama_supplier}`, badge:'orange', label:'Menunggu',
        })),
        ...kasbonList.filter(k=>k.status==='diajukan').map(k=>({
          teks: `Setujui Pengajuan Kas ${k.no_pengajuan}`, badge:'orange', label:'Menunggu',
        })),
        ...stokMenipis.map(s=>({
          teks: `Stok ${s.nama_barang} menipis (${s.qty} ${s.satuan})`, badge:'merah', label:'Stok',
        })),
      ];
      setTindakan(daftarTindakan);

    } catch(err) {}
    finally { setLoading(false); }
  }

  const jam = new Date().getHours();
  const sapaan = jam < 12 ? '☀️ Selamat pagi' : jam < 15 ? '🌤️ Selamat siang' : jam < 19 ? '🌅 Selamat sore' : '🌙 Selamat malam';

  return (
    <>
      <Topbar
        judul="Dashboard"
        sub={`${sapaan}, ${user?.nama?.split(' ')[0] || 'User'} 👋`}
      />

      <main className="main-content">

        {/* STAT CARDS */}
        <section className="stat-grid">
          <StatCard icon="🛒" angka={String(stats.totalPO)} label="Total PO (Pengadaan)" warna="biru"
            trend={formatRp(stats.totalNilaiPO)} trendArah="up" />
          <StatCard icon="📦" angka={String(stats.stokMenipis)} label="Stok Menipis (Gudang)" warna={stats.stokMenipis>0?'merah':'hijau'}
            trend={stats.stokMenipis>0 ? '⚠️ perlu restock' : '✅ aman'} trendArah={stats.stokMenipis>0?'down':'up'} />
          <StatCard icon="🏦" angka={formatRp(stats.totalKas)} label="Total Kas & Bank" warna="hijau"
            trend="Saldo tersedia" trendArah="up" />
          <StatCard icon="📄" angka={formatRp(stats.totalPiutang)} label="Piutang Belum Lunas" warna="orange"
            trend="Outstanding AR" trendArah="down" />
        </section>

        {/* BOTTOM GRID */}
        <section className="bottom-grid">

          {/* TABEL PO TERBARU */}
          <div className="card">
            <div className="card-header">
              <h3>🛒 SPB / PO Terbaru</h3>
            </div>
            {loading ? (
              <p style={{ fontSize:'13px', color:'#888', padding:'12px' }}>Memuat data...</p>
            ) : poTerbaru.length === 0 ? (
              <p style={{ fontSize:'13px', color:'#888', padding:'12px' }}>Belum ada data SPB</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>No. SPB</th>
                    <th>Supplier</th>
                    <th>Proyek</th>
                    <th>Nilai</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {poTerbaru.map((p,i)=>(
                    <tr key={i}>
                      <td><strong>{p.no_spb}</strong></td>
                      <td>{p.nama_supplier}</td>
                      <td>{p.nama_proyek||'-'}</td>
                      <td>{formatRp(p.total_nilai)}</td>
                      <td>{badgeStatusPO(p.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* PANEL KANAN */}
          <div className="right-panel">

            {/* Aktivitas */}
            <div className="card">
              <div className="card-header">
                <h3>🔔 Aktivitas Terbaru</h3>
              </div>
              {loading ? (
                <p style={{ fontSize:'13px', color:'#888', padding:'12px' }}>Memuat...</p>
              ) : aktivitas.length === 0 ? (
                <p style={{ fontSize:'13px', color:'#888', padding:'12px' }}>Belum ada aktivitas</p>
              ) : (
                <ul className="activity-list">
                  {aktivitas.map((a, i) => (
                    <li className="activity-item" key={i}>
                      <span className={`activity-dot ${a.dot}`}></span>
                      <div>
                        <p>{a.teks}</p>
                        <small>{a.modul} · {waktuRelatif(a.waktu)}</small>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Perlu Tindakan */}
            <div className="card">
              <div className="card-header">
                <h3>⚡ Perlu Tindakan ({tindakan.length})</h3>
              </div>
              {loading ? (
                <p style={{ fontSize:'13px', color:'#888', padding:'12px' }}>Memuat...</p>
              ) : tindakan.length === 0 ? (
                <p style={{ fontSize:'13px', color:'#27ae60', padding:'12px' }}>✅ Tidak ada tindakan tertunda</p>
              ) : (
                <ul className="todo-list">
                  {tindakan.map((t, i) => (
                    <li className="todo-item" key={i}>
                      <span>{t.teks}</span>
                      <span className={`badge ${t.badge}`}>{t.label}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>
        </section>

      </main>
    </>
  );
}

export default Dashboard;